export { RedeemCopilotContext, useRedeemCopilot } from "./context";
export { RedeemCopilotChat } from "./components/Chat";
export { COPILOT_URL, WARNING_MESSAGE } from "./constants";

import { COPILOT_CHOICES } from "./instructions";

export const GREETING_MESSAGE = COPILOT_CHOICES.GREET_USER;
